<template>
  <a-radio-group v-bind="dynamicAttrs"  @change="changeValue" :defaultValue="modelValue">
    <slot />
  </a-radio-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { app } from '@/libs/app';
import { Radio } from 'ant-design-vue';
import './styles.scss';

app.use(Radio);

export default defineComponent({
  name: 'RadioGroup',
  props: {
    dynamicAttrs: {},
    modelValue: String,
  },
  emits: ['update:modelValue'],
  methods: {
    changeValue(e: any) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
});
</script>
